import React from 'react';
import '../../App.css';
import Cards from "../Cards";
import { projects } from "../../projects";

function Products() {
  return (
    <>
      <Cards projects={projects} />
    </>
  );
}

export default Products;

